<dsd-modal
  id="modale-annuler"
  [buttonPrimaryLabel]="'caad.modale.annuler' | translate"
  [buttonSecondaryLabel]="'caad.modale.continuer' | translate"
  [show]="showValue"
  aria-labelledby="modale-annuler"
  (dsdModalSecondaryClick)="showDialog()"
  (dsdModalPrimaryClick)="redirectionAccueil()">
  <h2 slot="title">{{ 'caad.modale.titre' | translate }}</h2>
  <p>{{ 'caad.modale.label' | translate }}</p>
</dsd-modal>
